import * as React from 'react';
import { SVGProps } from 'react';

const VerificationBadge = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        {...props}
    >
        <path
            d="M2.928 10.84a14.853 14.853 0 0 1-1.907-6.536.962.962 0 0 1 .52-.897L7.534.247a1 1 0 0 1 .934 0l5.992 3.16a.962.962 0 0 1 .52.897 14.852 14.852 0 0 1-1.907 6.537 13.942 13.942 0 0 1-4.576 4.856.919.919 0 0 1-.992 0 13.943 13.943 0 0 1-4.576-4.856Z"
            fill="#0063FB"
        />
        <path
            d="m5.5 8.5 2 1.5 4-4"
            stroke="#fff"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default VerificationBadge;
